import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { reactQueryClient } from "./service";
import { QueryClientProvider } from "react-query";
import { BrowserRouter as Router } from "react-router-dom";
import { ApolloProvider } from "@apollo/client/react";
import { apolloClient } from "./apolloClient";
import { ConfigProvider } from "antd";
import { NEW_UI_THEME } from "./theme/theme";
import { I18nProvider } from "./i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ApolloProvider client={apolloClient}>
    <Router>
      <QueryClientProvider client={reactQueryClient}>
        <ConfigProvider theme={NEW_UI_THEME}>
          <I18nProvider>
            <App />
          </I18nProvider>
        </ConfigProvider>
      </QueryClientProvider>
    </Router>
  </ApolloProvider>
);

reportWebVitals();
